module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.formValue,
      "fields": _vm.fields,
      "model": "switches",
      "buttons": _vm.buttons,
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-312fba36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/SwitchForm.vue
// module id = 983
// module chunks = 2